// The Help page: a two-step orientation (it is the reference the tours point to).
const help = {
  title: 'Help',
  steps: () => [
    {
      target: 'help-nav',
      title: 'Topics',
      body: 'One topic per part of the portal, grouped by who uses it. Type in the search box to filter. You only see topics your role can use.',
      placement: 'right'
    },
    {
      target: 'help-topic',
      title: 'A topic',
      body: 'A short summary, numbered steps with tips, related topics, and a button that opens the page and runs its tour. Print sends the topic to your printer or a PDF.',
      placement: 'top'
    }
  ]
};

export default help;
